import { render, staticRenderFns } from "./DeadlineDateForm.vue?vue&type=template&id=2fe7dea4&scoped=true"
import script from "./DeadlineDateForm.vue?vue&type=script&lang=js"
export * from "./DeadlineDateForm.vue?vue&type=script&lang=js"
import style0 from "./DeadlineDateForm.vue?vue&type=style&index=0&id=2fe7dea4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe7dea4",
  null
  
)

export default component.exports